module.exports = __webpack_public_path__ + "static/assets/350b3fedada4d8a309d5072a192bf04c.svg";